import React from 'react';
import { IconProps } from './types';

const HangUpCallIcon: React.FC<IconProps> = props => {
  const { height = '24', width = '24' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="14" cy="14.0002" rx="14" ry="14.0002" fill="#E92C2C" />
      <mask id="mask0_14977_208014" maskUnits="userSpaceOnUse" x="2" y="3" width="24" height="23">
        <rect
          width="16"
          height="16"
          transform="matrix(-0.707101 0.707113 -0.707101 -0.707113 25.627 14.314)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_14977_208014)">
        <path
          d="M6.32314 13.819C7.33665 12.8055 8.5505 12.0435 9.96471 11.5331C11.3789 11.0221 12.8285 10.7668 14.3134 10.7671C15.7983 10.7668 17.2478 11.0221 18.662 11.5331C20.0762 12.0435 21.2901 12.8055 22.3036 13.819C22.445 13.9604 22.5157 14.1254 22.5157 14.314C22.5157 14.5025 22.445 14.6675 22.3036 14.8089L20.3944 16.7181C20.2844 16.8281 20.1509 16.891 19.9938 16.9067C19.8366 16.9224 19.6952 16.8831 19.5695 16.7889L17.6132 15.4453C17.4875 15.3511 17.3893 15.2491 17.3186 15.1394C17.2478 15.0291 17.2125 14.9032 17.2125 14.7618L17.1889 12.4755C16.2933 12.2398 15.3505 12.1219 14.3605 12.1219C13.3706 12.1219 12.3963 12.2398 11.4378 12.4755L11.4378 14.6911C11.4378 14.8325 11.3985 14.978 11.32 15.1276C11.2414 15.2766 11.1393 15.3982 11.0136 15.4925L9.05726 16.7889C8.9237 16.8753 8.78039 16.9127 8.62734 16.9011C8.47398 16.8891 8.3423 16.8281 8.23231 16.7181L6.32314 14.8089C6.18172 14.6675 6.11101 14.5025 6.11101 14.314C6.11101 14.1254 6.18172 13.9604 6.32314 13.819Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
export default HangUpCallIcon;
